export const HOST = ['https://dnha-dev.play-analytics.com', 'https://dnha.play-analytics.com'];

export const API = {
    // 获取所有的environment环境  https://tigertech.feishu.cn/wiki/wikcnqa3KJdbF1yxTiDadumUYYe
    environments: '/environment/get'
};
